(() => {
  const preferenceKey = 'ls-country-choice-until';
  const hasChoice = () => {
    try {
      return Number(localStorage.getItem(preferenceKey)) > Date.now();
    } catch {
      return false;
    }
  };

  class CountryRecommendation extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelector('[data-stay]').addEventListener('click', () => this.dismiss(), options);
      this.querySelector('form').addEventListener('submit', () => this.dismiss(), options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const selector = document.querySelector('.modal-region-toggle');
          this.dismiss();
          selector?.focus();
        }
      }, options);
      // The existing selector submits with form.submit(), without a submit event.
      document.addEventListener('click', (event) => {
        if (event.target.closest('.region-modal__button')) this.dismiss();
      }, { ...options, capture: true });
      window.addEventListener('storage', () => {
        if (hasChoice()) this.dismiss(false);
      }, options);
      if (window.Shopify?.designMode || hasChoice()) return;
      this.recommend();
    }

    disconnectedCallback() {
      this.events?.abort();
      clearInterval(this.timer);
    }

    async recommend() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${encodeURIComponent(this.dataset.currentCountry)}&language[enabled]=false`, {
          signal: this.events.signal,
        });
        if (!response.ok) return;
        const data = await response.json();
        const country = data.suggestions?.[0]?.parts?.country?.handle;
        if (!['AT', 'DE'].includes(country) || country === this.dataset.currentCountry) return;
        const content = this.querySelector(`[data-country="${country}"]`);
        if (!content || this.dismissed || hasChoice()) return;
        this.querySelector('[name="country_code"]').value = country;
        // The German market launches in German at /de-de.
        if (country === 'DE') this.querySelector('[name="locale_code"]').value = 'de';
        content.hidden = false;
        this.updateVisibility();
        this.timer = setInterval(() => this.updateVisibility(), 1000);
      } catch {
        // A missing recommendation or blocked request never interrupts shopping.
      }
    }

    updateVisibility() {
      if (this.dismissed || hasChoice()) {
        this.dismiss(false);
        return;
      }
      // Read the installed NA age app's result only. Never set its storage,
      // call its acceptance action, or show a top-layer dialog above its gate.
      let ageConfirmed = false;
      try {
        ageConfirmed = window.agecheckerVsARddsz9?.getHistory?.() === 'pass';
      } catch { /* No reliable age result: keep the recommendation hidden. */ }
      const blockingOverlay = document.querySelector(
        '#agp__noPeekScreen, .age-verification.popup-open, .popup-open, .modal--open, dialog[open]'
      );
      const ageOverlay = [...document.querySelectorAll('#agp__root .agp__wrapper')].some(
        (element) => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden'
      );
      this.hidden = !ageConfirmed || Boolean(blockingOverlay) || ageOverlay;
    }

    dismiss(remember = true) {
      this.dismissed = true;
      this.hidden = true;
      clearInterval(this.timer);
      if (remember) {
        try {
          localStorage.setItem(preferenceKey, String(Date.now() + 7 * 24 * 60 * 60 * 1000));
        } catch { /* Still dismissed for this page when storage is unavailable. */ }
      }
    }
  }

  if (!customElements.get('ls-country-recommendation')) {
    customElements.define('ls-country-recommendation', CountryRecommendation);
  }
})();
